import React from "react"
import { Helmet } from "react-helmet"

const InlineScript = props => {
  if (props?.children?.[0]) {
    return (
      <Helmet
        script={[
          {
            type: props?.type || "text/javascript",
            innerHTML: props?.children?.[0] || null,
          },
        ]}
      ></Helmet>
    )
  } else {
    return (
      <Helmet
        script={[
          {
            src: props?.src || null,
            async: props?.async || false,
            charSet: props?.charSet,
            defer: props?.defer || false,
          },
        ]}
      ></Helmet>
    )
  }
}

export default InlineScript
